module.exports = __webpack_public_path__ + "static/media/kohi-click-test-bridge.7de1c5e9.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/kohi-click-test/kohi-click-test-bridge.gif
 ** module id = 576
 ** module chunks = 0
 **/